import axios from 'axios'
import global from '@/global/variable.js'

// 获取角色列表
export function getList(data) {
  const url = global.requestUrl + '/role/list?limit=' + data.limit + '&page=' + data.page
  return axios.get(url)
}

// 创建角色信息
export function createOne(data) {
  const url = global.requestUrl + '/role/create'
  return axios.post(url, data)
}

// 更新角色信息
export function updateOne(data) {
  const url = global.requestUrl + '/role/update'
  return axios.post(url, data)
}

// 删除角色信息
export function deleteOne(data) {
  const url = global.requestUrl + '/role/delete/' + data.id
  return axios.get(url)
}
